export const ageRegex = /^\d{0,3}$/;
